import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
//import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { AltaUsuariosExternosEditComponent } from '../altausuariosexternos/altausuariosexternos-edit-component';
import { /* ActionGuard, LoginGuard, */ LogoutGuard } from '../../../core/_infrastructure/classes/guards/main.guard';
//import { AccessUsuarioExternoGuard, AccessMisDatosGuard } from '../../../_mantenimiento/usuarios/_classes/access.guard';

const usuariosRoutes: Routes = [
    {
        path: 'sede/asistentes/altausuariosexternos',
        data: {
            breadcrumb: 'Usuarios Externos',
            //menu0: 'GLOBAL',
            menu0: 'SEDE',
            //menu1: 'Usuarios'
        },
        children: [
            {
                path: 'create',
                component: AltaUsuariosExternosEditComponent,
                canActivate: [LogoutGuard()],

                data: {
                    breadcrumb: 'Nuevo Usuario Externo',
                    tipo: 1,
                },
            },
            {
                path: 'create2',
                component: AltaUsuariosExternosEditComponent,
                canActivate: [LogoutGuard()],

                data: {
                    breadcrumb: 'Nuevo Usuario Externo',
                    tipo: 6,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(usuariosRoutes)],
    exports: [RouterModule],
})
export class AltaUsuariosExternosRoutingModule {}
